








import Vue from "vue";
import { ProductListFilter } from "@/model/product-list-filter";

export default Vue.extend({
	name: "ActiveProductSearchLabel",
	props: {
		activeFilter: {
			type: Object as () => ProductListFilter,
			required: true
		}
	},
	watch: {
		activeFilter() {
		}
	},
	computed: {
		currentSearchValue(): string {
			return this.activeFilter.getQuery();
		}
	}
});
